import behindIcon from "Assets/reports/behind-icon.png";
import React from "react";
import "./ARMFloorIcon.scss";

export function ARMFloorIcon(props) {
  return <img className="arm-floor-icon" src={behindIcon} alt="Behind" {...props}/>;
}